import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@ui/primitives';
import { CalendarIcon, ChevronDown } from 'lucide-react';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite-no-reset.min.css';
import './datepicker.styles.css';
export const DateRangePickerComponent = (props)=>{
    var _ref, _ref1, _ref2, _ref3;
    const { value, dateRangeConfig } = props;
    return /*#__PURE__*/ _jsx(DateRangePicker, {
        value: value,
        className: cn('w-[210px] h-9 shadow-sm cursor-pointer hover:border-gray-700 focus-visible:outline-none', dateRangeConfig === null || dateRangeConfig === void 0 ? void 0 : dateRangeConfig.className),
        showHeader: false,
        caretAs: ()=>/*#__PURE__*/ _jsx(ChevronDown, {
                className: "h-4 w-4 text-muted-foreground"
            }),
        placeholder: (_ref = dateRangeConfig === null || dateRangeConfig === void 0 ? void 0 : dateRangeConfig.placeholder) !== null && _ref !== void 0 ? _ref : 'Date Range',
        size: (_ref1 = dateRangeConfig === null || dateRangeConfig === void 0 ? void 0 : dateRangeConfig.size) !== null && _ref1 !== void 0 ? _ref1 : 'sm',
        placement: (_ref2 = dateRangeConfig === null || dateRangeConfig === void 0 ? void 0 : dateRangeConfig.placement) !== null && _ref2 !== void 0 ? _ref2 : 'auto',
        label: /*#__PURE__*/ _jsx(CalendarIcon, {
            color: "#A3A3A3"
        }),
        onChange: props.onChange,
        format: (_ref3 = dateRangeConfig === null || dateRangeConfig === void 0 ? void 0 : dateRangeConfig.format) !== null && _ref3 !== void 0 ? _ref3 : 'dd-MM-yyyy',
        cleanable: true
    });
};
